import { useLocation, useNavigate } from 'react-router-dom'
import { AccountType } from '@/common/types'
import { NAVIGATION_COPY } from '@/locales/en'
import { Tabs, TabsList, TabsTrigger } from '@/common/ui/tabs'
import { AccountTabKey, getAvailableTabs, TAB_TO_ROUTE } from '../tabs'
import { getAccountPageTabFromPathname } from '@/common/navigation/accountRoutes'

type Props = {
    accountType?: AccountType
}

export default function AccountTabs({ accountType }: Props) {
    const location = useLocation()
    const navigate = useNavigate()
    const copy = NAVIGATION_COPY.account
    const detectedTab = getAccountPageTabFromPathname(location.pathname)
    const availableTabs = getAvailableTabs(accountType)
    const activeTab: AccountTabKey = availableTabs.includes(detectedTab) ? detectedTab : 'account'

    const onSelectTab = (tab: AccountTabKey) => {
        navigate(TAB_TO_ROUTE[tab])
    }

    const handleValueChange = (value: string) => {
        if (availableTabs.includes(value as AccountTabKey)) onSelectTab(value as AccountTabKey)
    }

    const TAB_LABELS: Record<AccountTabKey, string> = {
        settings: copy.tabs.accountSettings,
        account: copy.tabs.accountDetails,
        holders: copy.tabs.accountHolders,
    }

    return (
        <Tabs value={activeTab} onValueChange={handleValueChange}>
            <TabsList
                aria-label={copy.pageTitle}
                className="rounded-md inline-flex justify-start items-start h-auto p-0 bg-transparent"
            >
                {availableTabs.map((key) => (
                    <TabsTrigger
                        key={key}
                        value={key}
                        className="p-4 flex justify-start items-start gap-2.5 rounded-none border-b-[3px] border-transparent text-sm leading-5 text-content-secondary font-medium data-[state=active]:text-content-primary data-[state=active]:font-semibold data-[state=active]:border-brand-primary-emerald data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                    >
                        {TAB_LABELS[key]}
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
    )
}
